import firebase from 'firebase';
import 'firebase/firestore';
import "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyB2dNdhG6taRYk1bYZpRjReNBnNaAej3EY",
    authDomain: "sihah-online.firebaseapp.com",
    projectId: "sihah-online",
    storageBucket: "sihah-online.appspot.com",
    messagingSenderId: "796883626881",
    appId: "1:796883626881:web:0453167008e8a256f21680"
};

firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();
const storage = firebase.storage();

export {db, firebase, storage};